import type { UpdateInternalNoteBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { requestInternalNotesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUpdateRequestInternalNote(
  requestId: number,
): UseMutationResult<
  Response,
  Error,
  { body: UpdateInternalNoteBody; noteId: number }
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      body,
      noteId,
    }: {
      body: UpdateInternalNoteBody;
      noteId: number;
    }) =>
      apiClient
        .url(`/requests/${requestId}/internal-notes/${noteId}`)
        .patch(body)
        .res(),
    onError: () => {
      toast.add(
        { title: "Failed to update note", type: "error" },
        { timeout: 5000 },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: requestInternalNotesKeys.byRequestId(requestId),
      });
    },
  });
}
